"use client"

import { Cloud, Clock, Shield, Check } from "lucide-react"

const signals = [
  { icon: Cloud, label: "100% en la nube" },
  { icon: Clock, label: "Operativo en 24 h" },
  { icon: Shield, label: "Datos seguros por rol" },
  { icon: Check, label: "Sin instalaciones" },
]

export function TrustBar({ className = "" }: { className?: string }) {
  return (
    <section className={`border-t border-gray-100 bg-white ${className}`}>
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-4 sm:py-5">
        <div className="grid grid-cols-2 gap-x-3 gap-y-4 sm:flex sm:flex-wrap sm:items-center sm:justify-center sm:gap-x-10 sm:gap-y-3">
          {signals.map(({ icon: Icon, label }) => (
            <div key={label} className="flex items-center gap-2 text-xs sm:text-sm text-muted-foreground justify-center sm:justify-start">
              <Icon className="h-4 w-4 text-[#00676E]" />
              <span>{label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
